'use client'

import React from "react";
import dynamic from 'next/dynamic'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMessages, useTranslations } from "next-intl";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const Slider = dynamic(() => import('react-slick'), { ssr: false })

function ReviewsSection() {
  const t= useTranslations(`reviews`)
  const messages = useMessages()
  const reviews = Object.keys(messages.reviews)

  const settings = {
    dots:true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          dots:false,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          dots:false,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      }
    ]
  };

  // const reviews = [
  //   {
  //     text: "ROLZO's service is exceptional—simple booking and top-notch quality every time.",
  //     author: "John S."
  //   },
  //   {
  //     text: "Reliable, punctual, and efficient. ROLZO is the best car service I have ever used.",
  //     author: "Kate P."
  //   },
  //   {
  //     text: "I rely on ROLZO for every trip now and wouldn't consider any other options.",
  //     author: "Thomas T."
  //   },
  // ];

  return (
    <section className="slider-container bg-rolzo-white max-w-full  reviews-section">
      <div className="container py-[80px] ">

      <Slider {...settings}>
        {reviews.map((review, index) => (
          <div key={index} className="md:px-4 text-center mb-[30px] md:mb-0">
            <div className="text-[18px] md:text-[16px] h-full flex flex-col justify-between">
              <p className="line-clamp-2 leading-[1.5] text-[18px] md:text-[16px] font-light mb-6">{t(`${review}.text`)}</p>
              <p className="font-normal ">{t(`${review}.author`)}</p>
            </div>
          </div>
        ))}
      </Slider>
      </div>

    </section>
  );
}

export default ReviewsSection;